import { hasOwn } from "./has-own";
import { utc0Date, serverOtc0Date } from "./utc0";

type DateLike = number | string | Date;

interface Policies {
  fromServer: (value: DateLike) => Date;
  toServer: (value: DateLike) => Date;
  default: (value: DateLike) => Date;
  fromDb: (value: Date | null | undefined) => string;
}

const policies = {
  fromServer: utc0Date,
  toServer: serverOtc0Date,
  default: (v) => new Date(v),
  fromDb: (v) => (v ? v.toJSON() : ""),
} as const satisfies Policies;

type Policy = keyof Policies;

export default function transformDates<P extends Policy = "default">(
  date: DateLike,
  policy: P = "default" as P
): ReturnType<Policies[P]> {
  const converter = hasOwn(policies, policy)
    ? policies[policy]
    : policies.default;

  return converter(date as never) as ReturnType<Policies[P]>;
}
